import React from "react";
import FutureComponent from "./FutureComponent";
import SpotlightComponent from "./SpotlightComponent";

const LandingPage = () => {
  return (
    <div>
      <FutureComponent />
      <SpotlightComponent />
    </div>
  );
};

export default LandingPage;
